import { kebabCase } from "@utils/kebab-case"
import { ContentBlock } from "eddev/blocks"
import { useEffect, useRef } from "react"

const ParagraphBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div className="rich-text-content paragraph-block" dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

const HeadingBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    const id = kebabCase(props.innerHTML.replace(/<\/?[^>]+(>|$)/g, "").trim())
    return (
      <div className="rich-text-content heading-block" dangerouslySetInnerHTML={{ __html: props.innerHTML }} id={id} />
    )
  } else {
    return null
  }
}

const ListBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div className="rich-text-content list-block" dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

const ImageBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div className="rich-text-content image-block" dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

const CodeBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div className="rich-text-content code-block" dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

const QuoteBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div className="rich-text-content quote-block" dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

const EmbedBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div className="rich-text-content embed-block" dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

const HTMLBlock = (props: ContentBlock) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!props.innerHTML) return

    let attempts = 0
    const maxAttempts = 10
    const delay = 100 // ms

    const tryInject = () => {
      // @ts-ignore
      if (typeof window.Cal === "undefined" && attempts < maxAttempts) {
        attempts++
        setTimeout(tryInject, delay)
        return
      }

      const tempContainer = document.createElement("div")
      tempContainer.innerHTML = props.innerHTML ?? ""

      const scriptTags = Array.from(tempContainer.querySelectorAll("script"))
      scriptTags.forEach((script) => script.remove())

      if (containerRef.current) {
        containerRef.current.innerHTML = tempContainer.innerHTML
      }

      scriptTags.forEach((script) => {
        if (script.src) {
          const newScript = document.createElement("script")
          newScript.src = script.src
          newScript.async = true
          document.body.appendChild(newScript)
        } else {
          try {
            eval(script.innerHTML)
          } catch (error) {
            console.error("Error executing inline script:", error)
          }
        }
      })
    }

    tryInject()

    return () => {
      document.querySelectorAll("script").forEach((script) => {
        if (script.src && props.innerHTML?.includes(script.src)) {
          script.remove()
        }
      })
    }
  }, [props.innerHTML])

  if (typeof props.innerHTML === "string") {
    return <div className="rich-text-content html-block" ref={containerRef} />
  } else {
    return null
  }
}

export default {
  "core/paragraph": ParagraphBlock,
  "core/heading": HeadingBlock,
  "core/list": ListBlock,
  "core/image": ImageBlock,
  "core/code": CodeBlock,
  "core/quote": QuoteBlock,
  "core/embed": EmbedBlock,
  "core/html": HTMLBlock,
}
